import React from "react";
import ChecklistIcon from "icons/ChecklistIcon";

export default function ChecklistIconButton(props) {
  const { setOpenChecklist, itemId } = props;
  function handleChecklistIconButtonClick() {
    setOpenChecklist((currOC) => {
      return { ...currOC, isOpen: true, itemId: itemId };
    });
  }
  return (
    <button
      className="checklist-icon-button"
      onMouseDown={handleChecklistIconButtonClick}
    >
      <ChecklistIcon />
    </button>
  );
}
